import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CodeService } from '../../shared';

export const countryValidator: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  return CodeService.getCountryCode(control.value) ? null : { countryError: true };
};
